import { api } from './client';

export type ApiTokenScope = 'tasks:read' | 'tasks:write';

export interface ApiTokenInfo {
  id: number;
  name: string;
  prefix: string;
  scopes: ApiTokenScope[];
  expiresAt: string;
  lastUsedAt: string | null;
  lastUsedIp: string | null;
  revokedAt: string | null;
  createdAt: string;
  active: boolean;
}

export interface ApiAccess {
  enabled: boolean;
  tokens: ApiTokenInfo[];
}

export const apiTokensApi = {
  listOwn: () => api.get<ApiAccess>('/api/v1/me/api-tokens'),
  createOwn: (input: { name: string; scopes: ApiTokenScope[]; expiresInDays: number }) =>
    api.post<{ token: string; info: ApiTokenInfo }>('/api/v1/me/api-tokens', input),
  revokeOwn: (id: number) => api.post<void>(`/api/v1/me/api-tokens/${id}/revoke`),
  adminGet: (userId: number) => api.get<ApiAccess>(`/api/v1/admin/users/${userId}/api-access`),
  adminSet: (userId: number, enabled: boolean) => api.put<void>(`/api/v1/admin/users/${userId}/api-access`, { enabled }),
  adminRevoke: (userId: number, tokenId: number) => api.post<void>(`/api/v1/admin/users/${userId}/api-tokens/${tokenId}/revoke`),
};
